// src/components/Status.jsx
import React from "react";
import { useAuth } from "../../contexts/SupabaseAuthContext";

const Status = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <p></p>;
  }

  return (
    <div>
      {user ? (
        <p></p>
      ) : (
        <p></p>
      )}
    </div>
  );
};

export default Status;
